(() => {
  const notices = document.querySelectorAll('[data-uk-cart-notice][hidden]');
  if (!notices.length) return;

  // Use Shopify's existing region signal only; do not collect or send referral data.
  const showForRegion = () => {
    const region = window.Shopify?.customerPrivacy?.getRegion?.();
    if (typeof region === 'string' && region.toUpperCase().startsWith('GB')) {
      notices.forEach((notice) => { notice.hidden = false; });
    }
  };

  if (window.Shopify?.customerPrivacy?.getRegion) {
    showForRegion();
  } else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
      if (!error) showForRegion();
    });
  }
})();
